export default function(array, id, idprop = "id") {
  for (let x of array) if (x[idprop] === id) return x;
  return null;
}
